export default __webpack_public_path__ + "57a7d26cafa2dff715276f42e4b9e393.png";